import PageTitle from '../PageTitle'
import PageSubtitle from '../PageSubtitle'
import ProjectCardSmall from './ProjectCardSmall'

export default function ProjectGallery (props){

  return(
    <div style={{display: 'flex', background: "#80a3db"}}>
      <div style={{width: '7vw'}}></div>
      <div style={{width: '86vw', marginBottom: '150px'}}>
        <div>
          <PageTitle
            pageTitle = 'Explore research projects'
            />
          <PageSubtitle
            pageSubtitle = 'Find a team below and watch your medical career leap forward'
            />
        </div>
          <div style = {{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}>
            {
              (
                props.projectData &&
                props.projectData.map(p => (
                  <ProjectCardSmall
                    key={p.project_id}
                    project_id={p.project_id}  
                    project_title={p.project_title}
                    institution={p.institution}
                    specialty={p.specialty}
                    state_name={p.state_name}
                    completion={p.completion}
                    publication_type={p.publication_type}
                    study_type={p.study_type}
                    formal_name={p.formal_name}
                    skills={p.skills}
                    summary={p.summary}
                    projectModal={props.projectModal}
                    setProjectModal={props.setProjectModal}
                  />
                ))
              )
            }
          </div>
      </div>
    <div style={{width: '7vw'}}></div>
    </div>
  ) 
}




